import { Divider } from 'antd'
import Avatar from 'components/Avatar'
import Button from 'components/Button'
import TextAreas from 'components/Form/TextArea'
import CalenderIcon from 'components/icons/CalendarIcon'
import CarIcon from 'components/icons/CarIcon'
import NoteListIcon from 'components/icons/NoteListIcon'
// import DriveStatus from 'modules/Drives/Components/DriveTable/DriveStatus/index.js'
import moment from 'moment'
import React, { Fragment } from 'react'
import SuccessMessage from 'utils/SuccessMessage'
import corporateRequest from 'utils/corporateRequest'
import {
  BoldText,
  CenteredTitle,
  CompanyName,
  DomainName,
  FooterFlex,
  FormItem,
  ItemsFlex,
  LightText,
  ModeText,
  StyledDrawer,
} from './Style/style'

import { Form } from '../../../Roles/ViewRole/DriveDrawers/DrivesUiComponents/FormSection/Style/style'

const CancelDriveDrawer = ({ cancelDrawer, setCancelDrawer, driveData }) => {
  const cancelDrive = async data => {
    let payLoad = {
      note: data?.reason,
    }
    try {
      await corporateRequest.patch(
        `/corporates/virtualDrive/${driveData?.virtualDriveInstituteCampusMap?.[0]?.driveId}/cancel`,
        payLoad
      )
      setCancelDrawer(false)
      SuccessMessage('Drive cancelled Successfully')
    } catch (error) {}
  }

  const content = () => {
    return (
      <Fragment>
        <CenteredTitle>
          <Avatar
            background
            src={''}
            size={56}
            IconName={
              driveData?.virtualDriveInstituteCampusMap?.[0]?.instituteCampusName?.split(
                ''
              )?.[0]
            }
            font={18}
          />
          <CompanyName>
            {
              driveData?.virtualDriveInstituteCampusMap?.[0]
                ?.instituteCampusName
            }
          </CompanyName>
          <DomainName>{driveData?.corporate?.industry} </DomainName>
        </CenteredTitle>
        <Divider type="horizontal" />
        <ItemsFlex>
          <LightText>
            <CalenderIcon />
            Date
          </LightText>
          <BoldText>
            {moment(driveData?.startDate).format('DD/MM/YYYY')} -{' '}
            {moment(driveData?.endDate).format('DD/MM/YYYY')}
          </BoldText>
        </ItemsFlex>
        <ItemsFlex>
          <LightText>
            <CarIcon />
            Drive Mode
          </LightText>
          <ModeText>
            {driveData?.driveMode?.replace('_', '  ').toLowerCase()}
          </ModeText>
        </ItemsFlex>
        <ItemsFlex>
          <LightText>
            <NoteListIcon />
            Drive Status
          </LightText>
          <BoldText>
            {/* <DriveStatus
              status={
                driveData?.virtualDriveInstituteCampusMap?.[0]?.corporateStatus
              }
              bordered={true}
            /> */}
          </BoldText>
        </ItemsFlex>

        <Divider type="horizontal" />
        <Form
          scrollToFirstError
          onFinish={cancelDrive}
          id="cancel_reason"
          layout="vertical"
        >
          <FormItem
            name="reason"
            rules={[
              {
                required: true,
                message: 'Please enter the reason for cancel..!',
              },
            ]}
          >
            <TextAreas placeholder="Reason for Cancel" />
          </FormItem>
        </Form>
      </Fragment>
    )
  }
  const footer = () => {
    return (
      <FooterFlex right>
        <Button.Secondary
          text="Close"
          onClick={() => {
            setCancelDrawer(false)
          }}
        />
        <Button.Primary
          htmlType="submit"
          form="cancel_reason"
          text="Cancel Drive"
        />
      </FooterFlex>
    )
  }
  return (
    <StyledDrawer
      title={<h3>Cancel Drive</h3>}
      placement="right"
      closable={true}
      onClose={() => {
        setCancelDrawer(false)
      }}
      visible={cancelDrawer}
      content={content()}
      footer={footer()}
    />
  )
}

export default CancelDriveDrawer
